"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveReferralRequestBodyToJSON = exports.RemoveReferralRequestBodyFromJSONTyped = exports.RemoveReferralRequestBodyFromJSON = void 0;
function RemoveReferralRequestBodyFromJSON(json) {
    return RemoveReferralRequestBodyFromJSONTyped(json, false);
}
exports.RemoveReferralRequestBodyFromJSON = RemoveReferralRequestBodyFromJSON;
function RemoveReferralRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referralId': json['referralId'],
    };
}
exports.RemoveReferralRequestBodyFromJSONTyped = RemoveReferralRequestBodyFromJSONTyped;
function RemoveReferralRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'referralId': value.referralId,
    };
}
exports.RemoveReferralRequestBodyToJSON = RemoveReferralRequestBodyToJSON;
